import { Outlet, Navigate } from '@/util/react-router-dom';
import { useCurrentUser } from '@/contexts/current-user-context';

export function PublicOutlet() {
  const { user } = useCurrentUser();
  return user && user.isPreTfa !== 'true' ? <Navigate to="/" replace /> : <Outlet />;
}
